<template>
  <div>
    <SidebarSearch
      @submit="submitForm"
      @clear="clearForm"
    >
      <SearchCollapse
        :expanded="true"
        title="Dados Gerais"
      >
        <NxInputDocument
          @update:value="handleInputUpdate('document', $event)"
        />
        <NxInputName @update:value="handleInputUpdate('nome', $event, false)" />
        <NxInput
          name="numProtocolo"
          type="text"
          label="Número do Protocolo:"
          placeholder="Digite o Número do Protocolo:"
          @update:value="handleInputUpdate('numProtocolo', $event, false)"
        ></NxInput>
        <NxPersonType @update:value="handleInputUpdate('tipoPessoa', $event)" />
        <NxRadioButton
          class="w-75 mr-2"
          label="Situação da Conta Corrente"
          name="situacaoContaCorrente"
          :listOptions="[
            { value: 'ATIVA', text: 'Ativa' },
            { value: 'INATIVA', text: 'Inativa' }
          ]"
          @update:value="
            handleInputUpdate('situacaoContaCorrente', $event, false)
          "
        />
      </SearchCollapse>

      <NxInputDateRange
        label="Período de Referência:"
        @update:InitialValue="
          handleInputDateUpdate('dataCriacaoInicial', $event, false)
        "
        @update:FinalValue="
          handleInputDateUpdate('dataCriacaoFinal', $event, false)
        "
      />

      <SearchCollapse title="Instituição">
        <NxSelectPA @update:value="handleSelectUpdate('paIds', $event)" />
        <NxSelectRegional
          @update:value="handleSelectUpdate('nomeRegional', $event)"
        />
        <NxSelectFuncionario
          :variable="employeeTypes.GERENTE"
          @update:value="handleSelectUpdate('gerenteId', $event)"
        />
      </SearchCollapse>

      <SearchCollapse title="Responsável">
        <NxSelectFuncionario
          :variable="employeeTypes.RESPONSAVEL"
          @update:value="handleSelectUpdate('responsavelId', $event)"
        />
        <NxSelectResponsavelGrupo
          @update:value="handleSelectUpdate('gruposResponsaveisId', $event)"
        />
      </SearchCollapse>

      <SearchCollapse title="Produto">
        <NxSelectProduto
          @update:value="handleSelectUpdate('produtosId', $event)"
        />
        <NxInputNumberRange
          v-if="checkBoardType(boardTypes.COBRANCA)"
          label="Dias em atraso:"
          @update:InitialValue="handleInputUpdate('diasAtrasoInicio', $event)"
          @update:FinalValue="handleInputUpdate('diasAtrasoFinal', $event)"
        />
        <NxInputMoneyRange
          @update:InitialValue="
            handleInputUpdate('valorInicial', $event, false)
          "
          @update:FinalValue="handleInputUpdate('valorFinal', $event, false)"
        />
      </SearchCollapse>

      <SearchCollapse title="Origem">
        <NxSelectOrigem
          @update:value="handleSelectUpdate('origemIds', $event)"
        />
      </SearchCollapse>

      <SearchCollapse title="Tag">
        <NxSelectTag
          :key="'tag-select-' + clearKey"
          ref="selectTag"
          :onlyActive="true"
          :multiple="true"
          label="Tags:"
          @update:value="handleSelectUpdate('tagIds', $event)"
        />
      </SearchCollapse>

      <SearchCollapse
        title="Ajuizamento"
        v-if="checkBoardType(boardTypes.AJUIZAMENTO)"
      >
        <NxInput
          name="numProcesso"
          type="text"
          label="Número do Processo:"
          placeholder="Digite o Número do Processo"
          @update:value="handleInputUpdate('numeroProcesso', $event)"
        ></NxInput>
        <NxInput
          name="instancia"
          type="text"
          label="Instância:"
          placeholder="Digite a Instância"
          @update:value="handleInputUpdate('instancia', $event)"
        ></NxInput>
        <NxSelectAjuizamentoAssunto
          @update:value="handleSelectUpdate('assuntoId', $event)"
        />
        <NxSelectAjuizamentoComarca
          @update:value="handleSelectUpdate('comarcaId', $event)"
        />
        <NxSelectAjuizamentoFase
          @update:value="handleSelectUpdate('faseId', $event)"
        />
        <NxSelectAjuizamentoObjetoAcao
          @update:value="handleSelectUpdate('objetoAcaoId', $event)"
        />
        <NxSelectAjuizamentoPrognostico
          @update:value="handleSelectUpdate('prognosticoId', $event)"
        />
        <NxSelectAjuizamentoAdvogado
          labelText="Advogado Responsável:"
          @update:value="handleSelectUpdate('advogadoResponsavel', $event)"
        />
        <NxSelectAjuizamentoAdvogado
          labelText="Advogado Contrário:"
          @update:value="handleSelectUpdate('advogadoContrario', $event)"
        />
        <NxInput
          name="dataDistribuicao"
          type="date"
          label="Data Distribuição:"
          :max="getCurrentDate()"
          @update:value="handleInputUpdate('dataDistribuicao', $event, false)"
        ></NxInput>
        <NxInput
          name="dataAndamento"
          type="date"
          label="Último Andamento:"
          :max="getCurrentDate()"
          @update:value="handleInputUpdate('ultimoAndamento', $event, false)"
        ></NxInput>
      </SearchCollapse>

      <!-- <SearchCollapse title="Redes Sociais">
        <NxInput
        name="utmCampaign"
        type="text"
        label="UTM Campaign:"
        placeholder="Digite o UTM Campaign"
      ></NxInput>
      </SearchCollapse> -->
    </SidebarSearch>
  </div>
</template>

<script>
import {
  NxInputDateRange,
  NxInputDocument,
  NxInputMoneyRange,
  NxInputName,
  NxInputNumberRange,
  NxPersonType
} from '@/components/nexum/components/custom-inputs/index.js'
import {
  NxSelectAjuizamentoAdvogado,
  NxSelectAjuizamentoAssunto,
  NxSelectAjuizamentoComarca,
  NxSelectAjuizamentoFase,
  NxSelectAjuizamentoObjetoAcao,
  NxSelectAjuizamentoPrognostico,
  NxSelectFuncionario,
  NxSelectPA,
  NxSelectProduto,
  NxSelectRegional,
  NxSelectInstancia,
  NxSelectResponsavelGrupo,
  NxSelectOrigem,
  NxSelectTag
} from '@/components/nexum/components/custom-selects/index.js'
import { NxRadioButton } from '@/components/nexum/components/index.js'
import SidebarSearch from '@/containers/layout/sidebars/SidebarSearch.vue'
import SearchCollapse from '@/containers/layout/sidebars/components/SearchCollapse.vue'
import boardTypes from '@/enums/enumBoardTypes.js'
import employeeTypes from '@/enums/enumEmployeeTypes.js'

export default {
  name: 'SidebarQuadro',
  components: {
    SidebarSearch,
    SearchCollapse,
    NxSelectPA,
    NxSelectRegional,
    NxSelectFuncionario,
    NxSelectAjuizamentoAssunto,
    NxSelectResponsavelGrupo,
    NxSelectAjuizamentoComarca,
    NxSelectAjuizamentoAdvogado,
    NxSelectAjuizamentoFase,
    NxSelectAjuizamentoObjetoAcao,
    NxSelectAjuizamentoPrognostico,
    NxSelectProduto,
    NxSelectInstancia,
    NxSelectOrigem,
    NxSelectTag,
    NxInputDocument,
    NxInputName,
    NxInputNumberRange,
    NxRadioButton,
    NxPersonType,
    NxInputMoneyRange,
    NxInputDateRange
  },
  props: {
    board: {
      type: Object,
      required: true,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      clearKey: 0, // Key para forçar re-render dos componentes de select
      // Form data devem seguir as nomenclaturas esperadas pelo backend
      form: {
        nome: null,
        document: null,
        paIds: null,
        nomeRegional: null,
        gerenteId: null,
        responsavelId: null,
        gruposResponsaveisId: null,
        produtosId: null,
        diasAtrasoInicio: null,
        diasAtrasoFinal: null,
        numeroProcesso: null,
        instancia: null,
        assuntoId: null,
        comarcaId: null,
        faseId: null,
        objetoAcaoId: null,
        prognosticoId: null,
        advogadoResponsavel: null,
        advogadoContrario: null,
        dataDistribuicao: null,
        ultimoAndamento: null,
        numProtocolo: null,
        valorInicial: null,
        valorFinal: null,
        origemIds: null,
        tagIds: null
      },
      boardTypes: boardTypes,
      employeeTypes: employeeTypes
    }
  },
  methods: {
    submitForm () {
      // TODO: encode the name before sendind it
      // this.form.nome = encodeURIComponent(this.form.nome)
      if (this.form.numeroProcesso) {
        this.form.numeroProcesso = this.form.numeroProcesso.replace(/[-./]/g, '')
      }
      this.$nextTick(() => {
        this.$emit('search', this.form)
      })
    },
    clearForm () {
      this.$root.$emit('clearForm')
      // Limpa todos os campos do formulário
      Object.keys(this.form).forEach(key => {
        this.form[key] = null
      })
      // Incrementa a key para forçar re-render dos componentes
      this.clearKey++
      this.$nextTick(() => {
        this.submitForm()
      })
    },
    clearField (field) {
      this.form[field] = null
    },
    encodeSpecialChar (dataPropName, value) {
      this.form[dataPropName] = encodeURIComponent(value)
    },
    checkBoardType (typeDesired) {
      let currentType = this.board.tipoBoard
      return typeDesired === currentType
    },
    getCurrentDate () {
      let date = new Date()
      let day = String(date.getDate()).padStart(2, '0')
      let month = String(date.getMonth() + 1).padStart(2, '0')
      let year = date.getFullYear()

      let currentDate = year + '-' + month + '-' + day

      return currentDate
    },
    handleSelectUpdate (fieldName, selectedValue) {
      // If to clear multiple select
      if (Array.isArray(selectedValue) && !selectedValue.length) {
        this.clearField(fieldName)
        return
      }
      // If to clear single select and update both types
      if (selectedValue) {
        this.form[fieldName] = Array.isArray(selectedValue)
          ? selectedValue.map((v) => (v.hasOwnProperty('value') ? v.value : v))
          : selectedValue.hasOwnProperty('value')
            ? selectedValue.value
            : selectedValue
      } else {
        this.clearField(fieldName)
      }
    },
    handleInputUpdate (fieldName, inputedValue, clean = true) {
      if (inputedValue) {
        // Se for um objeto, usa o '.value'
        const value = typeof inputedValue === 'object' ? inputedValue.value : inputedValue

        if (fieldName === 'numeroProcesso') {
          this.form[fieldName] = value.replace(/[^a-zA-Z0-9\-./]/g, '')
        } else {
          this.form[fieldName] = clean ? value.replace(/[^a-zA-Z0-9 ]/g, '') : value
        }
      } else {
        this.clearField(fieldName)
      }
    },
    handleInputDateUpdate (fieldName, inputedValue) {
      if (inputedValue) {
        let parts = inputedValue.split('-')
        let reversed = parts.reverse()
        let newDate = reversed.join('/')
        this.form[fieldName] = newDate
      } else {
        this.clearField(fieldName)
      }
    }
  }
}
</script>

<style>
input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type=number] {
  -moz-appearance: textfield;
}
</style>



// WEBPACK FOOTER //
// src/views/private/crm/board/search/SidebarQuadro.vue